import script from "./AddOfferConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOfferConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./AddOfferConfirmationModal.vue?vue&type=style&index=0&id=37de076c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37de076c"]])

export default __exports__